import { MiaPlaza } from "@/Reinforced.Typings";

/**
 * Convenience class for getting subject-specific constants.
 */
export default class SubjectHelper {
	public static GetTextClass(key: string): string {
		return `mia-text-subject-${SubjectHelper.SanitizeKeyForCss(key)}`;
	}

	public static GetBackgroundClass(key: string): string {
		return `mia-bg-subject-${SubjectHelper.SanitizeKeyForCss(key)}`;
	}

	public static GetBackgroundContrastClass(key: string): string {
		return `mia-bg-subject-contrast-${SubjectHelper.SanitizeKeyForCss(key)}`;
	}

	public static GetBackgroundImageClass(key: string): string {
		return `mia-bg-image-subject-${key}`;
	}

	public static GetTrKey(key: string): string {
		return `subject_${key}`;
	}

	public static SanitizeKeyForCss(key: string): string {
		return key.replace(/_/g, "-");
	}

	public static GetBorderClass(key: string): string {
		return `mia-border-subject-${key}`;
	}

	/**
	 * Make sure to synchronize changes here with CoreSubjects in the backend.
	 */
	public static GetCoreSubjects(): MiaPlaza.Model.Subject[] {
		return [
			MiaPlaza.Model.Subject.LanguageArts,
			MiaPlaza.Model.Subject.Math,
			MiaPlaza.Model.Subject.Science,
			MiaPlaza.Model.Subject.GeographyAndHistory,
		];
	}

	public static GetAllSubjects(): MiaPlaza.Model.Subject[] {
		return [
			...this.GetCoreSubjects(),
			MiaPlaza.Model.Subject.MusicAndArts,
			MiaPlaza.Model.Subject.ForeignLanguages,
			MiaPlaza.Model.Subject.LifeSkills,
			MiaPlaza.Model.Subject.BiblicalStudies,
		];
	}
}
